import React, { useRef } from "react";
import html2pdf from "html3pdf";
import { IoPrint } from "react-icons/io5";

const PrintHtml = ({ contentRef }) => {
  const iframeRef = useRef(null); // Ref to hold the iframe

  const printContent = async () => {
    const content = contentRef.current; // Access the content via ref
    const options = {
      margin: 1,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 5, // Increase scale for better quality
        useCORS: true, // Allow cross-origin content
      },
      jsPDF: {
        unit: "in",
        format: "A4", // A4: [8.27, 11.69] or Letter: [8.5, 11]
        orientation: "portrait", // 'landscape' for wide tables
      },
    };

    // Generate the PDF blob
    const pdfBlob = await html2pdf()
      .from(content)
      .set(options)
      .toPdf()
      .outputPdf("blob");

    // Create an object URL for the blob
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Use the iframe to load the PDF and trigger print
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.src = pdfUrl;
      iframe.onload = () => {
        iframe.contentWindow?.focus(); // Focus the iframe
        iframe.contentWindow?.print(); // Trigger the print dialog
      };
    }
  };

  return (
    <div className="print-law-library-btn-container">
      <button className="print-law-library-btn" onClick={printContent}>
        <IoPrint /> Print Content
      </button>
      {/* Hidden iframe for printing */}
      <iframe
        ref={iframeRef}
        style={{ display: "none" }} // Keep it hidden
        title="Print Frame"
      ></iframe>
    </div>
  );
};

export default PrintHtml;
